import * as THREE from 'three'
import { bezier2D } from '../../Utils/Bezier'
import Experience from '../../Experience'
import { ParametricGeometry } from 'three/examples/jsm/Addons.js'
import anim from '../../Utils/Anim'

export default class GreyIdea {
    constructor(_options) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.time = this.experience.time
        this.ui = this.experience.debug.ui

        // 
        this.setMesh()
        // this.setDebug()
    }

    setMesh() {
        this.geometry = new THREE.BoxGeometry(0.8, 0.8, 0.8)
        // this.material = new THREE.MeshNormalMaterial({ side: THREE.DoubleSide, wireframe: false })
        this.material = new THREE.MeshBasicMaterial({ color: new THREE.Color(0.9137254901960784, 0.592156862745098, 0.5686274509803921).multiplyScalar(0.5) })

        this.mesh = new THREE.Mesh(this.geometry, this.material)
        this.mesh.position.set(0, 0.41, -0.5)
        this.mesh.layers.enable(1)
        this.mesh.scale.set(0.2, 0.2, 0.2)
        this.mesh.rotation.x = Math.PI
        // this.mesh.scale.set(0.5, 0.5, 0.5)
        this.scene.add(this.mesh)


    }
    live() {

        anim.to(this.mesh.position, {
            duration: 0.5,
            easing: 'power1.in',
            y: 0.1,
            onComplete: () => {
                this.destroy()
            }
        })
        anim.to(this.mesh.scale, {
            duration: 0.5,
            easing: 'power1.in',
            x: 0,
            y: 0,
            z: 0,
        })
        anim.to(this.mesh.rotation, {
            duration: 0.5,
            easing: 'power1.in',
            x: Math.random() * Math.PI,
            y: Math.random() * Math.PI,
            z: Math.random() * Math.PI,
        })


    }
    destroy() {
        if (this.mesh) {
            this.scene.remove(this.mesh)
        }
        if (this.geometry) {
            this.geometry.dispose()
        }
        if (this.material) {
            this.material.dispose()
        }
  

    }

    setDebug() {
        if (this.experience.debug.active) {
            const ui = this.experience.debug.ui
            const blobFolder = ui.addFolder('blob')
            blobFolder.add(this.mesh.position, "x").min(-2).max(2).step(0.001)
            blobFolder.add(this.mesh.position, "y").min(-2).max(2).step(0.001)
            blobFolder.add(this.mesh.position, "z").min(-2).max(2).step(0.001)
            blobFolder.add(this.mesh.scale, "y").min(0).max(0.5).step(0.001)
        }
    }
    update() {

    }

}